export default __webpack_public_path__ + "static/l5-testimonial1-f1c87658a790b9d4fdef7f30365b8efb.jpg";